import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/pieces_/$pieceId')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/library/$pieceId',
      params: { pieceId: params.pieceId },
    });
  },
});
